import React from 'react';

const SkeletonLoader = ({ count = 6 }) => {
  return (
    <>
      <div className="skeleton-grid">
        {Array.from({ length: count }).map((_, index) => (
          <div key={index} className="skeleton-card">
            <div className="skeleton-image"></div>
            <div className="skeleton-content">
              <div className="skeleton-line skeleton-title"></div>
              <div className="skeleton-line skeleton-price"></div>
              <div className="skeleton-line skeleton-info"></div>
              <div className="skeleton-line skeleton-info-short"></div>
              <div className="skeleton-button"></div>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        .skeleton-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(min(320px, 100%), 1fr));
          gap: 24px;
          width: 100%;
          max-width: 1280px;
          margin: 0 auto;
          padding: 32px 16px;
        }

        .skeleton-card {
          background: linear-gradient(135deg, rgba(15, 23, 42, 0.45), rgba(30, 41, 59, 0.3));
          backdrop-filter: blur(12px);
          border-radius: 24px;
          overflow: hidden;
          border: 1px solid rgba(71, 85, 105, 0.2);
          min-height: 560px;
          animation: skeletonPulse 1.5s ease-in-out infinite;
        }

        .skeleton-image {
          width: 100%;
          height: 280px;
          background: linear-gradient(
            90deg,
            rgba(51, 65, 85, 0.3) 25%,
            rgba(71, 85, 105, 0.5) 50%,
            rgba(51, 65, 85, 0.3) 75%
          );
          background-size: 200% 100%;
          animation: skeletonShimmer 1.5s infinite;
        }

        .skeleton-content {
          padding: 20px;
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .skeleton-line {
          height: 16px;
          background: linear-gradient(
            90deg,
            rgba(51, 65, 85, 0.3) 25%,
            rgba(71, 85, 105, 0.5) 50%,
            rgba(51, 65, 85, 0.3) 75%
          );
          background-size: 200% 100%;
          border-radius: 8px;
          animation: skeletonShimmer 1.5s infinite;
        }

        .skeleton-title {
          width: 70%;
          height: 20px;
        }

        .skeleton-price {
          width: 50%;
          height: 24px;
        }

        .skeleton-info {
          width: 100%;
        }

        .skeleton-info-short {
          width: 60%;
        }

        .skeleton-button {
          width: 100%;
          height: 52px;
          background: linear-gradient(
            90deg,
            rgba(51, 65, 85, 0.3) 25%,
            rgba(71, 85, 105, 0.5) 50%,
            rgba(51, 65, 85, 0.3) 75%
          );
          background-size: 200% 100%;
          border-radius: 16px;
          margin-top: auto;
          animation: skeletonShimmer 1.5s infinite;
        }

        @keyframes skeletonShimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }

        @keyframes skeletonPulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.8;
          }
        }

        @media (max-width: 640px) {
          .skeleton-grid {
            grid-template-columns: 1fr;
            gap: 16px;
            padding: 16px 8px;
          }

          .skeleton-card {
            min-height: 500px;
          }

          .skeleton-image {
            height: 220px;
          }
        }
      `}</style>
    </>
  );
};

export default SkeletonLoader;

